import React from 'react';

export const icons = {
  alert_outline: (
    <g>
      <rect x="11" y="10" width="2" height="4" />
      <rect x="11" y="15" width="2" height="2" />
      <path d="M21.71,19.13,13.06,3.85A1.31,1.31,0,0,0,12,3.08a1.31,1.31,0,0,0-1.08.77L2.26,19.13c-.59,1-.11,1.87,1.08,1.87H20.63C21.82,21,22.3,20.15,21.71,19.13ZM4.63,19,12,6l7.35,13Z" />
    </g>
  ),
  alert: (
    <path d="M21.71,19.13,13.06,3.85a1.14,1.14,0,0,0-2.16,0L2.26,19.13c-.59,1-.11,1.87,1.08,1.87H20.63C21.82,21,22.3,20.15,21.71,19.13ZM13,17H11V15h2Zm0-3H11V10h2Z" />
  ),
  arrow_left: (
    <polygon points="21 11 5.84 11 13.33 3.52 11.92 2.1 3.43 10.59 3.43 10.59 2.02 12 3.43 13.41 11.92 21.9 13.33 20.48 5.84 13 21 13 21 11" />
  ),
  arrow_right: (
    <polygon points="3.02 11 18.17 11 10.68 3.52 12.1 2.1 20.58 10.59 20.58 10.59 22 12 20.58 13.41 12.1 21.9 10.68 20.48 18.17 13 3.02 13 3.02 11" />
  ),
  bar_chart: (
    <g>
      <rect x="16" y="3" width="4" height="18" />
      <rect x="10" y="9" width="4" height="12" />
      <rect x="4" y="14" width="4" height="7" />
    </g>
  ),
  book: (
    <g>
      <path d="M7,2H5.05A1,1,0,0,0,4,3V21a1,1,0,0,0,1.05,1H7Z" />
      <g>
        <rect x="11" y="7" width="6" height="2" />
        <path d="M20,2H8V22H20Zm-2,8H10V6h8Z" />
      </g>
    </g>
  ),
  bookmark_outline: (
    <path d="M17,2H6.94A1,1,0,0,0,6,3V22l6-3,6,3V3A1,1,0,0,0,17,2ZM16,18.74l-3.1-1.55L12,16.74l-.86.44L8,18.76V4h8Z" />
  ),
  bookmark: (
    <path d="M17,2H6.94A1,1,0,0,0,6,3V22l6-3,6,3V3A1,1,0,0,0,17,2Z" fillRule="evenodd" />
  ),
  box: (
    <path d="M4,20H20V9H4Zm4-8h8v2H8ZM3,4V8H21V4Z" fillRule="evenodd" />
  ),
  calendar: (
    <g>
      <path d="M20,4H18V2H16V4H8V2H6V4H4A1,1,0,0,0,3,5V21a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V5A1,1,0,0,0,20,4ZM5,20V10H19V20Z" />
      <rect x="7" y="12" width="2" height="2" />
      <rect x="11" y="12" width="2" height="2" />
      <rect x="15" y="12" width="2" height="2" />
      <rect x="15" y="16" width="2" height="2" />
      <rect x="11" y="16" width="2" height="2" />
      <rect x="7" y="16" width="2" height="2" />
    </g>
  ),
  cancel: (<polygon points="19.82 5.59 18.41 4.18 12 10.59 5.59 4.18 4.18 5.59 10.59 12 4.18 18.41 5.59 19.82 12 13.41 18.41 19.82 19.82 18.41 13.41 12 19.82 5.59" />),
  caret_down: (
    <polygon points="2 6 12.02 18.02 22.04 6 2 6" fillRule="evenodd" />
  ),
  check: (
    <polygon points="8.42 17.96 21 5.83 19.59 4.42 7.81 15.77 3.44 11.4 2.02 12.81 6.37 17.16 6.36 17.17 7.77 18.58 7.78 18.57 7.79 18.58 8.42 17.96" />
  ),
  checkbox_rounded: (
    <path
      d="M13.108.002a2.891 2.891 0 012.89 2.89v10.217A2.892 2.892 0 0113.108 16H2.891A2.892 2.892 0 010 13.109V2.892A2.892 2.892 0 012.891.002h10.217zM11.819 4L6.173 9.319 4.18 7.325 3 8.507l1.958 1.957 1.17 1.19.338-.317L13 5.181 11.819 4z"
      fillRule="evenodd"
    />
  ),
  checkbox_rounded_unchecked: (
    <g strokeMiterlimit={2} clipRule="evenodd">
      <path
        d="M13.108.002a2.891 2.891 0 012.89 2.89v10.217A2.892 2.892 0 0113.108 16H2.891A2.892 2.892 0 010 13.109V2.892A2.892 2.892 0 012.891.002h10.217z"
        fill="#fff"
      />
      <path
        d="M13.182.003l.074.002.074.005.073.007.072.008.073.01.071.012.071.013.07.016.07.017.069.018.068.021.067.022.067.023.066.025.065.027.065.028.063.03.063.031.062.033.061.034.06.035.059.037.058.039.058.039.056.041.055.043.054.043.053.045.052.046.051.047.049.049.049.049.047.051.046.052.045.053.043.054.043.055.041.057.039.057.039.058.037.059.035.06.034.061.033.062.031.063.03.063.028.065.027.065.025.066.023.067.022.067.021.068.018.069.017.07.016.07.013.071.012.071.01.073.008.072.007.073.005.074.002.074.001.074v10.217l-.001.075-.002.074-.005.073-.007.074-.008.072-.01.072-.012.072-.013.07-.016.071-.017.069-.018.069-.021.068-.022.068-.023.067-.025.066-.027.065-.028.064-.03.064-.031.063-.033.062-.034.061-.035.06-.037.059-.039.058-.039.057-.041.056-.043.055-.043.055-.045.053-.046.051-.047.051-.049.05-.049.048-.051.048-.052.046-.053.045-.054.043-.055.042-.056.041-.058.04-.058.038-.059.037-.06.036-.061.034-.062.033-.063.031-.063.029-.065.029-.065.026-.066.025-.067.024-.067.022-.068.02-.069.019-.07.017-.07.015-.071.014-.071.012-.073.01-.072.008-.073.007-.074.004-.074.003-.074.001H2.891l-.075-.001-.074-.003-.073-.004-.074-.007-.072-.008-.072-.01-.072-.012-.07-.014-.071-.015-.069-.017-.069-.019-.068-.02-.068-.022-.067-.024-.066-.025-.065-.026-.064-.029-.064-.029-.063-.031-.062-.033-.061-.034-.06-.036-.059-.037-.058-.038-.057-.04-.056-.041-.055-.042-.055-.043-.053-.045-.051-.046-.051-.048-.05-.048-.048-.05-.048-.051-.046-.051-.045-.053-.043-.055-.042-.055-.041-.056-.04-.057-.038-.058-.037-.059-.036-.06-.034-.061-.033-.062-.031-.063-.029-.064-.029-.064-.026-.065-.025-.066-.024-.067-.022-.068-.02-.068-.019-.069-.017-.069-.015-.071-.014-.07-.012-.072-.01-.072-.008-.072-.007-.074-.004-.073-.003-.074L0 13.109V2.892l.001-.074.003-.074.004-.074.007-.073.008-.072.01-.073.012-.071.014-.071.015-.07.017-.07.019-.069.02-.068.022-.067.024-.067.025-.066.026-.065.029-.065.029-.063.031-.063.033-.062.034-.061.036-.06.037-.059.038-.058.04-.057.041-.057.042-.055.043-.054.045-.053.046-.052.048-.051.048-.049L.897.8.948.753.999.707l.053-.045.054-.043.056-.043.056-.041.057-.039.058-.039.059-.037.06-.035.061-.034.062-.033.063-.031.064-.03.064-.028.065-.027.066-.025.067-.023.068-.022L2.1.111l.069-.018.069-.017.071-.016.07-.013.072-.012.072-.01.072-.008.074-.007.073-.005.074-.002.075-.001h10.217l.074.001zM2.894.502l-.065.001-.062.002-.06.004-.061.005-.06.007-.06.008-.059.01-.058.011-.058.013-.058.014-.056.015-.057.017-.056.018-.055.02-.054.02-.054.023-.053.023-.053.024-.052.026-.051.027-.05.028-.05.03-.049.03-.048.032-.047.033-.047.034-.045.035-.045.036-.044.037-.043.038-.042.039-.041.04-.04.041-.04.043-.038.043-.037.043-.036.045-.035.046-.034.046-.033.048-.031.048-.031.049-.029.049-.029.051-.027.051-.025.052-.025.052-.023.054-.022.053-.021.055-.019.055-.019.056-.016.056-.016.057-.014.058-.012.058-.012.058-.009.059-.009.06-.007.06-.005.06-.004.061-.002.062-.001.065v10.21l.001.065.002.062.004.06.005.061.007.06.009.06.009.059.012.058.012.058.014.058.016.056.016.057.019.056.019.055.021.054.022.054.023.053.025.053.025.052.027.051.029.05.029.05.031.049.031.048.033.047.034.047.035.045.036.045.037.044.038.043.04.042.04.041.041.04.042.04.043.038.044.037.045.036.045.035.047.034.047.033.048.031.049.031.05.029.05.029.051.027.052.025.053.025.053.023.054.022.054.021.055.019.056.019.057.016.056.016.058.014.058.012.058.012.059.009.06.009.06.007.061.005.06.004.062.002.065.001h10.21l.065-.001.062-.002.061-.004.06-.005.06-.007.06-.009.059-.009.058-.012.058-.012.058-.014.057-.016.056-.016.056-.019.055-.019.055-.021.053-.022.054-.023.052-.025.052-.025.051-.027.051-.029.049-.029.049-.031.048-.031.048-.033.046-.034.046-.035.045-.036.043-.037.043-.038.043-.04.041-.04.04-.041.039-.042.038-.043.037-.044.036-.045.035-.045.034-.047.033-.047.032-.048.03-.049.03-.05.028-.05.027-.051.026-.052.024-.053.024-.053.022-.054.02-.054.02-.055.018-.056.017-.057.015-.056.014-.058.013-.058.011-.058.01-.059.008-.06.007-.06.005-.06.004-.061.003-.062V2.831l-.003-.062-.004-.061-.005-.06-.007-.06-.008-.06-.01-.059-.011-.058-.013-.058-.014-.058-.015-.057-.017-.056-.018-.056-.02-.055-.02-.055-.022-.053-.024-.054-.024-.052-.026-.052-.027-.051-.028-.051-.03-.049-.03-.049-.032-.048-.033-.048-.034-.046-.035-.046-.036-.045-.037-.043-.038-.043-.039-.043-.04-.041-.041-.04-.043-.039-.043-.038-.043-.037-.045-.036-.046-.035-.046-.034-.048-.033-.048-.032-.049-.03-.049-.03-.051-.028-.051-.027-.052-.026-.052-.024-.054-.023-.053-.023-.055-.02-.055-.02-.056-.018-.056-.017-.057-.015-.058-.014-.058-.013-.058-.011-.059-.01-.06-.008-.06-.007-.06-.005-.061-.004-.062-.002-.065-.001H2.894z"
        fill="#686868"
      />
    </g>
  ),
  checkbox: (
    <g>
      <polygon points="8.36 15.17 9.77 16.58 9.78 16.57 9.79 16.58 10.17 16.2 18 8.83 16.59 7.42 9.82 13.79 7.44 11.4 6.02 12.81 8.37 15.16 8.36 15.17" />
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
    </g>
  ),
  checkbox_unchecked: (
    <g>
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
    </g>
  ),
  chevron_down: (
    <polygon points="20.47 6.34 11.98 14.83 3.5 6.34 2.08 7.76 11.98 17.66 13.4 16.24 21.88 7.76 20.47 6.34" />
  ),
  chevron_left: (
    <polygon points="17.27 3.52 15.86 2.1 7.38 10.59 7.38 10.59 5.96 12 7.38 13.41 15.86 21.9 17.27 20.48 8.79 12 17.27 3.52" />
  ),
  chevron_right: (
    <polygon points="16.48 10.59 16.48 10.59 8 2.1 6.59 3.52 15.07 12 6.59 20.48 8 21.9 16.48 13.41 17.9 12 16.48 10.59" />
  ),
  chevron_up: (
    <polygon points="12 6.34 10.59 7.76 2.1 16.24 3.52 17.66 12 9.17 20.48 17.66 21.9 16.24 12 6.34" />
  ),
  circle_check_outline: (
    <g>
      <polygon points="10.34 13.88 7.95 11.48 6.53 12.9 8.88 15.24 8.87 15.25 10.28 16.67 10.29 16.66 10.3 16.67 10.63 16.34 17.51 9.91 16.1 8.5 10.34 13.88" />
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
    </g>
  ),
  circle: (
    <g>
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
    </g>
  ),
  clipboard: (
    <path d="M18.94,4H14.53A2.5,2.5,0,0,0,12,1.54,2.46,2.46,0,0,0,9.47,4H4.94a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1V5A1,1,0,0,0,18.94,4ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3Zm6,17h-12V6H8a.94.94,0,0,0,0,.1V7A1,1,0,0,0,9,8h6a1,1,0,0,0,1-1V6h1.94Z" fillRule="evenodd" />
  ),
  clock: (
    <g>
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
      <polygon points="13.04 11 13.04 6 11.04 6 11.04 11 11.04 13 13.04 13 18.04 13 18.04 11 13.04 11" />
    </g>
  ),
  comment_highlight: (
    <g>
      <path d="M17,16H10.24l-.54.45L8,17.82V16H4V6h9l2-2H3A1,1,0,0,0,2,5V17a1,1,0,0,0,1,1H6v4l4.94-4H18a1,1,0,0,0,1-1V12l-2,2.13Z" fillRule="evenodd" />
      <path d="M22.43,3.73,21.26,2.54a.69.69,0,0,0-1,0l-1,1,2.08,2.17,1.05-1A.69.69,0,0,0,22.43,3.73Z" fillRule="evenodd" />
      <polygon points="12.93 9.96 12.93 12.06 14.99 12.06 20.68 6.38 18.58 4.21 12.93 9.96" fillRule="evenodd" />
      <rect x="6" y="13" width="9" height="1" />
    </g>
  ),
  comment_microphone: (
    <g>
      <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
      <g>
        <rect x="10.57" y="5.49" width="2.83" height="5.52" rx="1.41" ry="1.41" />
        <path d="M15.48,9.53a.5.5,0,0,0-1,0,2.49,2.49,0,1,1-5,0,.5.5,0,0,0-1,0,3.51,3.51,0,0,0,3,3.47v1a.5.5,0,0,0,1,0V13A3.51,3.51,0,0,0,15.48,9.53Z" />
      </g>
    </g>
  ),
  comment_question: (
    <g>
      <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
      <path d="M11,8.08a1.35,1.35,0,0,1,.21-.45,1,1,0,0,1,.35-.31A1.08,1.08,0,0,1,12,7.2a1,1,0,0,1,.69.24A1,1,0,0,1,13,8.2a.91.91,0,0,1-.11.5,1.49,1.49,0,0,1-.3.37l-.41.33a2.8,2.8,0,0,0-.42.39A2.21,2.21,0,0,0,11.21,11v.6h1.45l0-.52a1.28,1.28,0,0,1,.22-.45,2.14,2.14,0,0,1,.39-.39l.47-.34a2.3,2.3,0,0,0,.45-.42,2.14,2.14,0,0,0,.34-.59A2.37,2.37,0,0,0,14.72,8a2,2,0,0,0-.14-.69,1.92,1.92,0,0,0-.46-.69,2.55,2.55,0,0,0-.85-.54A3.47,3.47,0,0,0,12,5.91a2.84,2.84,0,0,0-1.1.21,2.44,2.44,0,0,0-.84.57,2.61,2.61,0,0,0-.54.86,3.17,3.17,0,0,0-.2,1.1H10.9A2.25,2.25,0,0,1,11,8.08Z" />
      <rect x="11.16" y="12.45" width="1.54" height="1.56" />
    </g>
  ),
  comment_text: (
    <g>
      <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
      <rect x="7" y="7" width="10" height="2" />
      <rect x="7" y="11" width="6" height="2" />
    </g>
  ),
  comment_thumbs_up: (
    <g>
      <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
      <g>
        <path d="M16.52,9.05a.45.45,0,0,0-.45-.51H12.85s.46-1.27.73-2.08-.1-1.33-.59-.84L10.23,8.39a.77.77,0,0,0-.23.56v4.44a.17.17,0,0,0,.17.17H15a.79.79,0,0,0,.73-.48s.84-3,.84-3.08Z" />
        <rect x="7.47" y="8.56" width="1.48" height="4.98" />
      </g>
    </g>
  ),
  comment: (
    <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
  ),
  cursor: (
    <path d="M3,13V4A1,1,0,0,1,4,3H20a1,1,0,0,1,1,1v9l-9,7Z" fillRule="evenodd" />
  ),
  dock_left: (
    <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H9V5H19Z" />
  ),
  dock_right: (
    <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM5,5H15V19H5Z" />
  ),
  dock_top: (
    <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM5,19V9H19V19Z" />
  ),
  document: (
    <g>
      <path d="M19,2H5A1,1,0,0,0,4,3V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1ZM6,20V4H18V20Z" />
      <polygon points="16 7 8 7 8 9 16 9 16 7 16 7" />
      <polygon points="16 11 8 11 8 13 16 13 16 11 16 11" />
      <polygon points="14 15 8 15 8 17 14 17 14 15 14 15" />
    </g>
  ),
  download: (
    <g>
      <polygon points="19 14 19 18 5 18 5 14 3 14 3 18 3 20 5.5 20 19.5 20 21 20 21 18 21 14 19 14" fillRule="evenodd" />
      <polygon points="12 15 16 11 13 11 13 4 11 4 11 11 8 11 12 15" fillRule="evenodd" />
    </g>
  ),
  edit: (
    <g>
      <path d="M20.69,5,19,3.29a1,1,0,0,0-1.41,0L16.18,4.7l3,3.13,1.51-1.41A1,1,0,0,0,20.69,5Z" fillRule="evenodd" />
      <polygon points="3 17.98 3 21 5.97 21 18.17 8.82 15.14 5.68 3 17.98" fillRule="evenodd" />
    </g>
  ),
  eraser: (
    <g>
      <polygon points="9.58 20.98 20.96 20.98 20.96 18.98 11.46 18.98 9.58 20.98" />
      <path d="M21.78,7.9,16.25,2.37a1.19,1.19,0,0,0-1.68,0L7.88,9.06,2.46,14.47a1.19,1.19,0,0,0,0,1.68L7.29,21h3.08l4.75-4.75,6.65-6.65A1.19,1.19,0,0,0,21.78,7.9ZM9.79,19H8.18L4.28,15.21l5-4.78L13.84,15Z" />
    </g>
  ),
  expand: (
    <g>
      <path d="M19,19H5V5h6.92l-2-2H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V14l-2-2Z" fillRule="evenodd" />
      <polygon points="13.98 3 16.84 5.87 9.36 13.36 10.77 14.77 18.26 7.28 21 10.02 21 3 13.98 3" fillRule="evenodd" />
    </g>
  ),
  flag: (
    <g>
      <path d="M10,19.58V2H9V19.6A2.44,2.44,0,0,0,7.06,22H12A2.45,2.45,0,0,0,10,19.58Z" />
      <path d="M16.06,2.44c-1.12.22-1.59.89-3,.89a3.45,3.45,0,0,1-2-.89V7.73a3.45,3.45,0,0,0,2,.89c1.44,0,1.86-.66,3-.87s3,.87,3,.87V3.33S17.23,2.21,16.06,2.44Z" />
    </g>
  ),
  folder: (
    <path d="M22,20H2V5A1,1,0,0,1,3,4h7a1.09,1.09,0,0,1,1,1V6H21a1,1,0,0,1,1,1Z" />
  ),
  grabber: (
    <g>
      <circle cx="14.03" cy="12" r="0.98" />
      <circle cx="14.03" cy="8" r="0.98" />
      <circle cx="14.03" cy="4" r="0.98" />
      <circle cx="14.03" cy="20" r="0.98" />
      <circle cx="14.03" cy="16" r="0.98" />
      <circle cx="10.03" cy="12" r="0.98" />
      <circle cx="10.03" cy="8" r="0.98" />
      <circle cx="10.03" cy="4" r="0.98" />
      <circle cx="10.03" cy="20" r="0.98" />
      <circle cx="10.03" cy="16" r="0.98" />
    </g>
  ),
  grid_4: (
    <path d="M3,10h7V3H3ZM14,3v7h7V3ZM3,21h7V14H3Zm11,0h7V14H14Z" fillRule="evenodd" />
  ),
  grid_9: (
    <g>
      <rect x="2" y="3" width="5" height="5" />
      <rect x="9" y="3" width="5" height="5" />
      <rect x="16" y="3" width="5" height="5" />
      <rect x="2" y="10" width="5" height="5" />
      <rect x="9" y="10" width="5" height="5" />
      <rect x="16" y="10" width="5" height="5" />
      <rect x="2" y="17" width="5" height="5" />
      <rect x="9" y="17" width="5" height="5" />
      <rect x="16" y="17" width="5" height="5" />
    </g>
  ),
  head: (
    <path d="M20.6,13.32,19.07,11a1,1,0,0,1-.13-.8,6.14,6.14,0,0,0,.17-1.41C19.11,5,15.82,2,11.77,2S4.43,5,4.43,8.77c0,.12,0,.24,0,.36h0v0c0,3.27,2.14,5.75,2.6,8.46a22.13,22.13,0,0,1,0,3.3,1,1,0,0,0,1,1h4.67a1,1,0,0,0,1-1.14c-.2-2.15,2-.45,3.77-1,.84-.27,1.3-2.83,1.48-4.08a1,1,0,0,1,.77-.84l.19,0A1,1,0,0,0,20.6,13.32ZM16,8.23c-2.51,2.3-1.52,4.33-4.3,4.33s-5-1.94-5-4.33,2.26-4,5-4S17.79,6.62,16,8.23Z" />
  ),
  heart_outline: (
    <path d="M16,4a5,5,0,0,0-4,2A5,5,0,0,0,3,9,4.52,4.52,0,0,0,4,11.9C4.61,12.66,12,20,12,20s7.32-7.14,8-8.11A4.54,4.54,0,0,0,21,9,5,5,0,0,0,16,4Zm2.42,6.71c-.41.53-3.36,3.5-6.4,6.49C8.91,14.09,5.85,11,5.49,10.61A2.59,2.59,0,0,1,5,9,3,3,0,0,1,8,6a3.5,3.5,0,0,1,2.4,1.23L12,9l1.61-1.77A3.51,3.51,0,0,1,16,6a3,3,0,0,1,3,3A2.54,2.54,0,0,1,18.43,10.71Z" />
  ),
  heart: (
    <path d="M16,4a5,5,0,0,0-4,2A5,5,0,0,0,3,9,4.52,4.52,0,0,0,4,11.9C4.61,12.66,12,20,12,20s7.32-7.14,8-8.11A4.54,4.54,0,0,0,21,9,5,5,0,0,0,16,4Z" />
  ),
  help_outline: (
    <g>
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
      <rect x="11.05" y="15.03" width="1.95" height="1.98" />
      <path d="M14.82,7.68A3.24,3.24,0,0,0,13.74,7a4.41,4.41,0,0,0-1.67-.27,3.61,3.61,0,0,0-1.4.26,3.11,3.11,0,0,0-1.07.72,3.31,3.31,0,0,0-.69,1.1,4,4,0,0,0-.26,1.39h2.07a2.86,2.86,0,0,1,.08-.71,1.72,1.72,0,0,1,.26-.58,1.31,1.31,0,0,1,.45-.39,1.37,1.37,0,0,1,.65-.15,1.21,1.21,0,0,1,.88.31,1.29,1.29,0,0,1,.32,1,1.15,1.15,0,0,1-.13.63,1.9,1.9,0,0,1-.39.46q-.24.21-.52.42a3.56,3.56,0,0,0-.53.5,2.81,2.81,0,0,0-.68,1.58V14H13l.06-.66a1.63,1.63,0,0,1,.28-.58,2.72,2.72,0,0,1,.5-.5l.6-.44a2.92,2.92,0,0,0,.58-.53,2.71,2.71,0,0,0,.44-.75,3,3,0,0,0,.18-1.11,2.54,2.54,0,0,0-.18-.88A2.44,2.44,0,0,0,14.82,7.68Z" />
    </g>
  ),
  help: (
    <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15h-2V15h2Zm2.4-6.46a2.71,2.71,0,0,1-.44.75,2.92,2.92,0,0,1-.58.53l-.6.44a2.72,2.72,0,0,0-.5.5,1.63,1.63,0,0,0-.28.58L13,14H11.12v-.76a2.81,2.81,0,0,1,.68-1.58,3.56,3.56,0,0,1,.53-.5q.28-.21.52-.42a1.9,1.9,0,0,0,.39-.46,1.15,1.15,0,0,0,.13-.63,1.29,1.29,0,0,0-.32-1,1.21,1.21,0,0,0-.88-.31,1.37,1.37,0,0,0-.65.15,1.31,1.31,0,0,0-.45.39,1.72,1.72,0,0,0-.26.58,2.86,2.86,0,0,0-.08.71H8.66A4,4,0,0,1,8.92,8.8a3.31,3.31,0,0,1,.69-1.1A3.11,3.11,0,0,1,10.68,7a3.61,3.61,0,0,1,1.4-.26A4.41,4.41,0,0,1,13.74,7a3.24,3.24,0,0,1,1.08.68,2.44,2.44,0,0,1,.58.88,2.54,2.54,0,0,1,.18.88A3,3,0,0,1,15.4,10.55Z" />
  ),
  highlight: (
    <g>
      <rect x="4" y="19" width="16" height="2" />
      <path d="M18.69,5.41a1,1,0,0,0,0-1.41L17,2.29a1,1,0,0,0-1.41,0L14.18,3.7l3,3.13Z" fillRule="evenodd" />
      <polygon points="16.17 7.82 13.14 4.68 4 13.97 4 17 6.97 17 16.17 7.82" fillRule="evenodd" />
    </g>
  ),
  home: (
    <polygon points="20.92 12 11.94 3.02 2.96 12 5 12 5 21 10 21 10 14 14 14 14 21 19 21 19 12 20.92 12" />
  ),
  info: (
    <path d="M12,2c-5.486,0 -10,4.514 -10,10c0,5.486 4.514,10 10,10c5.486,0 10,-4.514 10,-10c0,-5.486 -4.514,-10 -10,-10Zm-1,15l2,0l0,-7.253l-2,0l0,7.253Zm2,-10.253l-2,0l0,2l2,0l0,-2Z" />
  ),
  info_outline: (
    <g>
      <path d="M12,2c-5.486,0 -10,4.514 -10,10c0,5.486 4.514,10 10,10c5.486,0 10,-4.514 10,-10c0,-5.486 -4.514,-10 -10,-10Zm0,18c-4.389,0 -8,-3.611 -8,-8c0,-4.389 3.611,-8 8,-8c4.389,0 8,3.611 8,8c0,4.389 -3.611,8 -8,8l0,0Z" fillRule="nonzero" />
      <rect height="7.253" width="2" x="11" y="9.747" />
      <rect height="2" width="2" x="11" y="6.747" />
    </g>
  ),
  item_add: (
    <g>
      <path d="M5,5H17v7h2V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V18a1,1,0,0,0,1,1h8V17L5,17Z" />
      <polygon points="22 17 19 17 19 14 17 14 17 17 14 17 14 19 17 19 17 22 19 22 19 19 22 19 22 17" />
    </g>
  ),
  item_copy: (
    <g>
      <path d="M18,17V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V17a1,1,0,0,0,1,1H17A1,1,0,0,0,18,17Zm-2-1H4V4H16Z" />
      <path d="M21,7H20V20H6v1a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V8A1,1,0,0,0,21,7Z" />
    </g>
  ),
  item_edit: (
    <g>
      <path d="M21.69,4,20,2.29a1,1,0,0,0-1.41,0L17.18,3.7l3,3.13,1.51-1.41A1,1,0,0,0,21.69,4Z" />
      <polygon points="8 16 10.97 16 19.17 7.82 16.14 4.68 8 12.97 8 16" />
      <path d="M19,19H5V5h5.92l2-2H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V11l-2,2Z" />
    </g>
  ),
  item_remove: (
    <g>
      <path d="M5,5H17v7h2V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V18a1,1,0,0,0,1,1h8V17L5,17Z" />
      <polygon points="22.04 15.38 20.62 13.96 18 16.59 15.38 13.96 13.96 15.38 16.59 18 13.96 20.62 15.38 22.04 18 19.41 20.62 22.04 22.04 20.62 19.41 18 22.04 15.38" />
    </g>
  ),
  label_on: (
    <g>
      <path d="M10.76,3h2.75L20,21H17.36l-1.88-5.44h-7L6.43,21H3.93Zm4,10.6L12,5.66,9.15,13.6Z" />
    </g>
  ),
  label_off: (
    <g>
      <polygon points="12.56 15.58 15.48 15.58 17.36 21 20.03 21 16.61 11.54 12.56 15.58" />
      <path d="M20.52,2.06,15.13,7.46,13.51,3H10.76L5.43,17.16,1.92,20.67l1.41,1.41,18.6-18.6ZM12,5.66l1.26,3.63-4,4Z" />
    </g>
  ),
  link: (
    <g>
      <path d="M19.68,4.31a4.36,4.36,0,0,0-6.13,0L9.68,8.15a4.36,4.36,0,0,0,0,6.13l1.54-1.54a2.18,2.18,0,0,1,0-3l3.87-3.87A2.18,2.18,0,0,1,18.17,8.9L17,10.06a3.59,3.59,0,0,1,.27,2.81l2.44-2.44A4.36,4.36,0,0,0,19.68,4.31Z" />
      <path d="M12.75,11.24a2.18,2.18,0,0,1,0,3L8.91,18.16a2.18,2.18,0,0,1-3.08-3.08L7,13.92a3.59,3.59,0,0,1-.27-2.81L4.29,13.54a4.36,4.36,0,0,0,6.16,6.16l3.87-3.87a4.36,4.36,0,0,0,0-6.13Z" />
    </g>
  ),
  list_left: (
    <g>
      <rect x="8" y="3" width="13" height="3" />
      <rect x="3" y="3" width="3" height="3" />
      <rect x="3" y="10" width="3" height="3" />
      <rect x="3" y="17" width="3" height="3" />
      <rect x="8" y="10" width="13" height="3" />
      <rect x="8" y="17" width="13" height="3" />
    </g>
  ),
  list_right: (
    <g>
      <rect x="3" y="3" width="13" height="3" />
      <rect x="18" y="3" width="3" height="3" />
      <rect x="18" y="10" width="3" height="3" />
      <rect x="18" y="17" width="3" height="3" />
      <rect x="3" y="10" width="13" height="3" />
      <rect x="3" y="17" width="13" height="3" />
    </g>
  ),
  locked: (
    <g>
      <path d="M18 10h-2V6a4 4 0 1 0-8 0v4H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-8-4a2 2 0 1 1 4 0v4h-4z" />
    </g>
  ),
  maximize: (
    <g>
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
      <polygon points="11 17 13 17 13 13 17 13 17 11 13 11 13 7 11 7 11 11 7 11 7 13 11 13 11 17" />
    </g>
  ),
  menu: (
    <g>
      <rect x="3" y="3" width="18" height="3" />
      <rect x="3" y="10" width="18" height="3" />
      <rect x="3" y="17" width="18" height="3" />
    </g>
  ),
  microphone: (
    <g>
      <rect x="9.14" y="2.97" width="5.72" height="11.18" rx="2.86" ry="2.86" />
      <path d="M19.08,11.15a1,1,0,1,0-2,0,5.05,5.05,0,1,1-10.11,0,1,1,0,0,0-2,0,7.1,7.1,0,0,0,6.06,7v2a1,1,0,0,0,2,0v-2A7.1,7.1,0,0,0,19.08,11.15Z" />
    </g>
  ),
  minimize: (
    <g>
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
      <rect x="7" y="15" width="10" height="2" />
    </g>
  ),
  minus: (
    <rect x="3" y="11" width="18" height="2" />
  ),
  more: (
    <g>
      <circle cx="3.99" cy="12" r="1.96" />
      <circle cx="11.99" cy="12" r="1.96" />
      <circle cx="19.99" cy="12" r="1.96" />
    </g>
  ),
  mortar_board: (
    <g>
      <polygon points="12.36 9.24 6.2 13.18 12 16.89 24.02 9.22 12 1.54 -0.02 9.22 4.83 12.31 10.96 8.39 12.36 9.24" />
      <polygon points="4.99 14.09 4.99 17.41 12 22 19.01 17.41 19.01 14.09 12 18.65 4.99 14.09" />
    </g>
  ),
  move: (
    <polygon points="22.05 12 19 8.95 19 11 13 11 13 5 15.05 5 12 1.95 8.95 5 11 5 11 11 5 11 5 8.95 1.95 12 5 15.05 5 13 11 13 11 19 8.95 19 12 22.05 15.05 19 13 19 13 13 19 13 19 15.05 22.05 12" fillRule="evenodd" />
  ),
  not: (
    <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM4,12A8,8,0,0,1,16.82,5.66l-11.37,11A8,8,0,0,1,4,12Zm8,8A8,8,0,0,1,6.79,18.1l11.45-11A8,8,0,0,1,12,20Z" />
  ),
  pause: (
    <g>
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
      <rect x="9" y="8" width="2" height="8" />
      <rect x="13" y="8" width="2" height="8" />
    </g>
  ),
  pause_solo: (
    <g>
      <rect x="5.04" y="3" width="5" height="18" />
      <rect x="14.04" y="3" width="5" height="18" />
    </g>
  ),
  person: (
    <g>
      <path d="M12,12.92c2.6,0,4.61-3,4.61-5.84S15.15,2,12,2,7.37,4.25,7.37,7.08,9.39,12.92,12,12.92Z" />
      <path d="M12,15.54c-5.31,0-9.65-4.2-9.93,5.41a1,1,0,0,0,1,1H20.92a1,1,0,0,0,1-1C21.63,11.37,17.29,15.54,12,15.54Z" />
    </g>
  ),
  play: (
    <g>
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
      <polygon points="9 17.03 16.98 12.01 9 7.03 9 17.03" fillRule="evenodd" />
    </g>
  ),
  play_solo: (
    <polygon points="6.04 21 20.36 11.99 6.04 3.06 6.04 21" fillRule="evenodd" />
  ),
  plus: (
    <polygon points="21 11 13 11 13 3 11 3 11 11 3 11 3 13 11 13 11 21 13 21 13 13 21 13 21 11" />
  ),
  pointer_outline: (
    <path d="M8.95,6.56l6.92,6.34L13,13.57l2.28,5.1-1.65.71-2.28-5.22L9,16,8.95,6.56M6.92,2,7,20l3.51-2.73,2,4.69,5.34-2.31L15.81,15,20,14,6.92,2Z" />
  ),
  pointer: (
    <path d="M6.92,2,7,20l3.51-2.73,2,4.69,5.34-2.31L15.81,15,20,14,6.92,2Z" />
  ),
  print: (
    <g>
      <path d="M21,8H3A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H5v4H19V18h2a1,1,0,0,0,1-1V9A1,1,0,0,0,21,8ZM6,12H4V10H6Zm11,6v2H7V16H17Z" />
      <rect x="5.96" y="2.02" width="12.04" height="4.98" />
    </g>
  ),
  replay: (
    <path d="M20,12a8,8,0,1,1-2.59-5.87L14.57,9h7V2L18.86,4.73A10,10,0,1,0,22,12Z" fillRule="evenodd" />
  ),
  rotate_x: (
    <path d="M12.08,1.85C9.36,1.85,7.23,5.24,6.76,10L3.69,10l4.13,5.13L12,10,8.78,10c.42-3.62,1.93-6.13,3.3-6.13,1.61,0,3.42,3.48,3.42,8.13s-1.8,8.13-3.42,8.13c-.57,0-1.26-.18-2-1.53a1,1,0,1,0-1.76.94,4.19,4.19,0,0,0,3.74,2.58c3.09,0,5.42-4.36,5.42-10.13S15.17,1.85,12.08,1.85Z" />
  ),
  rotate_y: (
    <path d="M12,6.58C6.22,6.58,1.86,8.91,1.86,12c0,2.72,3.39,4.85,8.16,5.32l0,3.07,5.13-4.13L10,12l0,3.25c-3.62-.42-6.13-1.93-6.13-3.3,0-1.61,3.48-3.42,8.13-3.42s8.13,1.8,8.13,3.42c0,.57-.18,1.26-1.53,2a1,1,0,0,0,.94,1.76A4.19,4.19,0,0,0,22.13,12C22.13,8.91,17.77,6.58,12,6.58Z" />
  ),
  search: (
    <path d="M16.35,14.94a8.08,8.08,0,1,0-1.43,1.4l5.37,5.37,1.41-1.41ZM10,16a6,6,0,1,1,6-6A6,6,0,0,1,10,16Z" />
  ),
  spreadsheet: (
    <g>
      <path d="M18,4V20H6V4H18m1-2H5A1,1,0,0,0,4,3V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1Z" />
      <path d="M8,7V17h8V7Zm6,2v2H10V9Zm-4,6V13h4v2Z" />
    </g>
  ),
  stop: (
    <g>
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
      <rect x="8" y="8" width="8" height="8" />
    </g>
  ),
  stop_solo: (
    <g>
      <rect x="3.04" y="3" width="18" height="18" />
    </g>
  ),
  text_size: (
    <g>
      <polygon points="21 4 10 4 10 7 14 7 14 20 17 20 17 7 21 7 21 4" fillRule="evenodd" />
      <polygon points="3 14 6 14 6 20 9 20 9 14 12 14 12 11 3 11 3 14" fillRule="evenodd" />
    </g>
  ),
  thumbs_down: (
    <g>
      <path d="M22.08,13.11a1,1,0,0,1-1,1.12H14s1,2.8,1.62,4.59c.53,1.58-.23,2.93-1.31,1.85C12.7,19.12,8.5,14.59,8.5,14.59A1.71,1.71,0,0,1,8,13.36V3.53a.38.38,0,0,1,.38-.38H18.62a1.74,1.74,0,0,1,1.61,1.07s1.86,6.59,1.86,6.82Z" />
      <rect x="3" y="3.22" width="3" height="11" />
    </g>
  ),
  thumbs_up: (
    <g>
      <path d="M22.08,11.1a1,1,0,0,0-1-1.12H14s1-2.8,1.62-4.59c.53-1.58-.23-2.93-1.31-1.85C12.7,5.1,8.5,9.62,8.5,9.62A1.71,1.71,0,0,0,8,10.86v9.83a.38.38,0,0,0,.38.38H18.62A1.74,1.74,0,0,0,20.23,20s1.86-6.59,1.86-6.82Z" />
      <rect x="3" y="10" width="3" height="11" />
    </g>
  ),
  tools: (
    <g>
      <path d="M20.74,6.41a1,1,0,0,0,0-1.41L19,3.29a1,1,0,0,0-1.41,0L16.22,4.7l3,3.13Z" />
      <polygon points="3.04 17.98 3.04 21 6.01 21 10.9 16.12 7.87 13.09 3.04 17.98" />
      <polygon points="18.21 8.82 15.18 5.68 13.05 7.84 16.12 10.91 18.21 8.82" />
      <path d="M10.55,7.47A3.75,3.75,0,0,0,5.71,3.26L7.14,4.68A1.74,1.74,0,1,1,4.68,7.14L3.26,5.72a3.75,3.75,0,0,0,4.21,4.84l9.72,9.72a2.18,2.18,0,0,0,3.09-3.09Zm8.65,11.74a.76.76,0,1,1,0-1.08A.76.76,0,0,1,19.21,19.21Z" />
    </g>
  ),
  trash: (
    <g>
      <path d="M6,21a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V7H6Z" />
      <path d="M18,3H14V2H9.92V3H6A1,1,0,0,0,5,4V6H19V4A1,1,0,0,0,18,3Z" />
    </g>
  ),
  trending: (
    <g>
      <path d="M21.908,9.6l-8.15,7.853l-3.921,-3.853l-1.916,-1.88l-5.986,5.986l-1.865,-1.865l7.833,-7.833l3.781,3.71l2.092,2.055l6.302,-6.072l1.83,1.899Z" id="Path" />
      <path d="M16.035,5.697l7.912,0l0,7.912l-7.912,-7.912Z" id="Rectangle" />
    </g>
  ),
  upload: (
    <g>
      <polygon points="19 14 19 18 5 18 5 14 3 14 3 18 3 20 5.5 20 19.5 20 21 20 21 18 21 14 19 14" fillRule="evenodd" />
      <polygon points="11 15 13 15 13 8 16 8 12 4 8 8 11 8 11 15" fillRule="evenodd" />
    </g>
  ),
  unlock: (
    <g>
      <path d="M18,10H10V6a2,2,0,1,1,4,0V7h2V6A4,4,0,1,0,8,6v4H6a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V11A1,1,0,0,0,18,10Z" />
    </g>
  ),
  video: (
    <g>
      <polygon points="9 7.63 9 16.37 15.97 11.98 9 7.63" />
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
    </g>
  ),
  writing_edit: (
    <g>
      <path d="M18,4.06l.88-.88a.62.62,0,0,1,.88,0l1,1.07a.62.62,0,0,1,0,.88L19.87,6" fillRule="evenodd" />
      <polygon points="14.14 11.71 12.29 11.71 12.29 9.83 17.36 4.67 19.25 6.62 14.14 11.71" fillRule="evenodd" />
      <path d="M4,21l-.37-1.33c.15,0,3.24-.54,4.21-3l-.17,0c-1.27-.33-2.21-1.43-2.56-3.37s.07-2.78.45-3.12a1.56,1.56,0,0,1,1.67-.23c1,.39,2.18,1.78,2.4,4.41a5.14,5.14,0,0,1,0,.65A8.32,8.32,0,0,0,12.35,13h1.84a10.5,10.5,0,0,1-4.77,3.44C8.61,19.26,5.65,20.49,4,21ZM6.6,11.11a.1.1,0,0,0-.07,0c-.1.09-.31.57,0,1.72.35,1.37.81,2.06,1.55,2.26l.12,0a1.53,1.53,0,0,0,.09-.75c-.17-2-1-3-1.53-3.24A.46.46,0,0,0,6.6,11.11Z" />
    </g>
  ),
  x: (
    <polygon points="19.82 5.59 18.41 4.18 12 10.59 5.59 4.18 4.18 5.59 10.59 12 4.18 18.41 5.59 19.82 12 13.41 18.41 19.82 19.82 18.41 13.41 12 19.82 5.59" />
  ),
  zoom_in: (
    <g>
      <path d="M10,1.92a8,8,0,1,0,4.88,14.42l5.37,5.37,1.41-1.41-5.35-5.35A8,8,0,0,0,10,1.92ZM10,16a6,6,0,1,1,6-6,6,6,0,0,1-6,6Z" />
      <polygon points="11 6.13 8.92 6.13 8.92 8.92 6.13 8.92 6.13 11 8.92 11 8.92 13.79 11 13.79 11 11 13.79 11 13.79 8.92 11 8.92 11 6.13 11 6.13" />
    </g>
  ),
  zoom_out: (
    <g>
      <path d="M10,1.92a8,8,0,1,0,4.88,14.42l5.37,5.37,1.41-1.41-5.35-5.35A8,8,0,0,0,10,1.92ZM10,16a6,6,0,1,1,6-6,6,6,0,0,1-6,6Z" />
      <polygon points="13.79 8.92 6.13 8.92 6.13 11 13.79 11 13.79 8.92 13.79 8.92" />
    </g>
  ),
};
